(function ($, window, document, undefined) {
Accordion = ( function() {

	function Constructor() {

		this.init = function () {
			var accordionItems = document.querySelectorAll('.accordion-body');
			accordionItems.forEach((item) => {
				item.addEventListener('click', (e) => {
					item.classList.toggle('active');
				});
			});
		};
	}
	return new Constructor();

}() );
})(jQuery, window, document);
